import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import SubadminList from "../../features/manageSubAdmin/subAdminList";

const ManageSubadmin = () => {

  const navigate = useNavigate();

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Sub-Admin</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage Sub-Admin
        </p>
      </div>

      <div className="cards">

        <SubadminList />
      </div>
    </MainContainer>
  );
};

export default ManageSubadmin;
